// composables/useActivityTracker.js
import { onMounted, onUnmounted } from 'vue'

export function useActivityTracker() {
  const LAST_ACTIVITY_KEY = 'lastUserActivity'

  // Функция для записи текущего времени как последняя активность
  const updateLastActivity = () => {
    const timestamp = Date.now()
    localStorage.setItem(LAST_ACTIVITY_KEY, timestamp.toString())
  }

  // Функция для проверки активности за последние 5 часов
  const wasActiveInLastHours = (hours = 5) => {
    const lastActivityStr = localStorage.getItem(LAST_ACTIVITY_KEY)

    if (!lastActivityStr) {
      return false // Если нет записей об активности
    }

    const lastActivity = parseInt(lastActivityStr)
    const hoursInMs = hours * 60 * 60 * 1000 // конвертируем часы в миллисекунды
    const timeDifference = Date.now() - lastActivity

    return timeDifference <= hoursInMs
  }

  // Получить время последней активности в удобочитаемом формате
  const getLastActivityTime = () => {
    const lastActivityStr = localStorage.getItem(LAST_ACTIVITY_KEY)

    if (!lastActivityStr) {
      return null
    }

    const lastActivity = parseInt(lastActivityStr)
    return new Date(lastActivity)
  }

  // События которые считаются активностью
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ]

  // Throttle функция чтобы не записывать слишком часто
  const throttle = (func, limit) => {
    let inThrottle
    return function() {
      const args = arguments
      const context = this
      if (!inThrottle) {
        func.apply(context, args)
        inThrottle = true
        setTimeout(() => inThrottle = false, limit)
      }
    }
  }

  // Throttled версия updateLastActivity (обновляем максимум раз в 30 секунд)
  const throttledUpdateActivity = throttle(updateLastActivity, 5000)

  // Функция для начала отслеживания
  const startTracking = () => {
    // Записываем активность при первом запуске
    // updateLastActivity()

    // Добавляем слушатели событий
    activityEvents.forEach(event => {
      document.addEventListener(event, throttledUpdateActivity, true)
    })
  }

  // Функция для остановки отслеживания
  const stopTracking = () => {
    activityEvents.forEach(event => {
      document.removeEventListener(event, throttledUpdateActivity, true)
    })
  }

  // Автоматически начинаем отслеживание при подключении
  onMounted(() => {
    startTracking()
  })

  // Останавливаем отслеживание при размонтировании
  onUnmounted(() => {
    stopTracking()
  })

  return {
    updateLastActivity,
    wasActiveInLastHours,
    getLastActivityTime,
    startTracking,
    stopTracking
  }
}